/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    import Languages = DealerwareWebComponents.Languages;

    getDealerwareWebComponentsModule().constant(
        'kpiHelpMessages', {
            avg_time_on_lot: {
                title: 'Avg Time on Lot',
                message: 'Average amount of collective time vehicles spent in "Returned", "In Prep" and "Staged" states'
            },
            avg_time_not_in_service: {
                title: 'Avg Time not in Service',
                message: 'Average amount of collective time vehicles spent in "Maintenance" or "Hard Hold" states'
            },
            total_fuel_charges: {
                title: 'Total Fuel Charges',
                message: 'Dollar amount of fuel consumed while vehicles were under contract'
            },
            tolls_incurred: {
                title: 'Tolls Incurred',
                message: 'Dollar amount of toll charges incurred by the dealership'
            },
            contract_tolls: {
                title: 'Contract Tolls',
                message: 'Dollar amount of tolls charges while a vehicle was under contract'
            }
        }
    );

    export class KpisController {
        public static $inject: string[] = [
            '$window',
            '$mobilityCompanyAuthentication',
            '$state',
            'DealerwareKpisModel',
            '$dealerwareNotification',
            'kpiHelpMessages',
            'AppConfig',
            'MicroFrontendOrigin',
            '$dealerwareInternationalizationData'
        ];

        private _dateRangeDisplay: string;

        public collapsed: boolean;
        public showSettings: boolean;
        public loading: boolean;
        public dateRangeType: string = 'last';
        public daysBack: number = 30;
        public interval: string = 'days';
        public startDate: Date = new Date();
        public endDate: Date = new Date();
        public timeZone = '';
        public kpis: any;
        public appConfig : any;
        public microFrontendOrigin : string;
        private programCarUtilizationEnabled: boolean;
        private NA_LABEL = 'N/A';
        public labels            : {};

        constructor(public $window: any,
                    public $auth: any,
                    private $state: any,
                    public kpisModel: any,
                    public $dealerwareNotification: any,
                    public helpMessages: any,
                    public appConfig : any,
                    public microFrontendOrigin : string,
                    public $dealerwareInternationalizationData: any
        ) {
            this.getLabels('dashboard');
            this.$state = $state;
            this.timeZone = this.$auth.location.time_zone_name;
            this.programCarUtilizationEnabled = $auth.location.settings.program_car_utilization;
            this.loadData(true);
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
            .getLabels()
            .then( function(res) {
                _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                _self.updateDateRangeDisplay();
                },
                function(error: any) {
                    _self.$dealerwareNotification.apiError(error);
                }
            );
        }

        private get dateRange() : any {
            if (this.dateRangeType === 'last') {
                return {
                    start: moment().subtract(this.daysBack, this.interval).tz(this.timeZone).format('YYYY-MM-DD'),
                    end: moment().subtract(1, 'day').tz(this.timeZone).format('YYYY-MM-DD')
                };
            } else {
                return {
                    start: moment(this.startDate).tz(this.timeZone).format('YYYY-MM-DDT00:00:00'),
                    end: moment(this.endDate).add(1, 'day').tz(this.timeZone).format('YYYY-MM-DDT23:59:59')
                };
            }
        }

        private get dateRangeDisplay() : string {
            return this._dateRangeDisplay;
        }

        private updateDateRangeDisplay() : void {
            if (this.dateRangeType === 'last') {
                this._dateRangeDisplay = (this.labels && this.labels.kpi) ? this.labels.kpi.in_the + ' ' + [this.getStateLabelDict(this.dateRangeType), this.daysBack, this.getStateLabelDict(this.interval)].join(' ') : '';
            } else {
                this._dateRangeDisplay = (this.labels && this.labels.kpi) ?  this.labels.kpi.between + ' ' + moment(this.startDate).format('YYYY-MM-DD') + ' ' + this.labels.kpi.and + ' ' + moment(this.endDate).add(1, 'day').format('YYYY-MM-DD') : '';
            }
        }

        public toggleCollapsed() : void {
            this.collapsed = !this.collapsed;
        }

        public toggleSettings() : void {
            this.showSettings = !this.showSettings;
        }

        public showHelp(type: string) : void {
            this.$dealerwareNotification.alert(this.helpMessages[type].title, this.helpMessages[type].message);
        }

        public loadData(initial: boolean = false) : void {
            var requestParams: { [key: string]: string } = { location_id: this.$auth.location.id },
                _self = this;

            if (!initial) {
                requestParams['start_date'] = this.dateRange.start,
                requestParams['end_date'] = this.dateRange.end
            }

            this.loading = true;
            this.kpisModel.get({
                promise: true,
                params: requestParams
            }).then(
                function(kpis: any) {
                    _self.kpis = kpis;
                    _self.updateDateRangeDisplay();
                },
                function(response: any) { _self.$dealerwareNotification.error('There was a problem loading KPIs'); }
            ).finally(
                function() {
                    _self.loading = false;
                    _self.showSettings = false;
                }
            );
        }

        public programCarUtilization() {
            if(!(this.kpis && this.kpis.data)) {
                return;
            }
            const percentage = parseFloat(this.kpis.data.program_car_utilization);
            return isNaN(percentage)
                ? this.NA_LABEL
                : `${Math.round(percentage * 100)}%`;
        }

        private getStateLabelDict(key: string) {
            return this.labels.kpi[key];
        }
    }

    getDealerwareWebComponentsModule().controller('KpisController', KpisController);

    export class KpisDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'KpisController';
        public controllerAs     : string    =   'kpisController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/dashboard_widgets/kpis/kpis_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareKpis",() => new KpisDirective());
}
